import React from 'react';
import './App.css';
import './layouts/Footer.js'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import {store, persistor} from './redux/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import Index from './components/Index';
import About from './components/About';
import Contact from './components/Contact';
import TeamDistribution from './components/TeamDistribution.js';
import Rota from './components/Rota.js';
import MediaBooking from './components/MediaBooking';
import Onboarding from './components/Onboarding';
import OnboardingDocument from './components/OnboardingDocument';
import Events from './components/Events';
import TeamAbsences from './components/TeamAbsences'
import RequestAbsences from './components/RequestAbsences';
import ProductionReady from './components/ProductionReady'
import SkillsMatrix from './components/SkillsMatrix';
import TeamBirthdays from './components/TeamBirthdays.js';
import EventDetails from './components/EventDetails.js';
import MemberRegistration from './components/MemberRegistration.js';
import ProcessImprovements from './components/ProcessImprovements.js';
import TeamMemberProfile from './components/TeamMemberProfile.js';
import BestPractices from './components/BestPractices.js';
import BroadcastEmail from './components/BroadcastEmail.js';
import MediaEvents from './components/MediaEvents.js';
import ManageUsers from './components/ManageUsers.js';
import ManageEvents from './components/ManageEvents.js';
import MemberProfileUpdate from './components/MemberProfileUpdate.js';
import MediaClockIn from './components/MediaClockIn.js';
import EventDetailsAdmin from './components/EventDetailsAdmin.js';
import EventDetailsNonMembers from './components/EventDetailsNonMembers.js';
import ManageMembersClockin from './components/ManageMembersClockin.js';
import TeamMemberProfileAdminAccess from './components/TeamMemberProfileAdminAccess.js';
import MemberPasswordReset from './components/MemberPasswordReset.js';
import MemberPasswordResetRequest from './components/MemberPasswordResetRequest.js';
import ManageRota from './components/ManageRota.js';
import ManageConfig from './components/ManageConfig.js';
import ManageAbsences from './components/ManageAbsences.js';
import ManageMyAbsences from './components/ManageMyAbsences.js';
import ManageRotaRoles from './components/ManageRotaRoles.js';
import CreateRota from './components/CreateRota.js';
import ManageProdChecklist from './components/ManageProdChecklist.js';
import InProductionRoom from './components/InProductionRoom.js';
import AddIncident from './components/AddIncident.js';
import ViewIncident from './components/ViewIncident.js';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
      <div className="App">
        <Router>
          <Routes>
            <Route path='/' element={<Index/>} />
            <Route path='/about' element={<About/>} />
            <Route path='/contact' element={<Contact/>} />
            <Route path='/teamdistribution' element={<TeamDistribution/>} />
            <Route path='/rota' element={<Rota/>} />
            <Route path='/mediabooking' element={<MediaBooking/>} />
            <Route path='/onboarding' element={<Onboarding/>} />
            <Route path='/documentation' element={<OnboardingDocument/>} />
            <Route path='/events' element={<Events/>} />      
            <Route path='/mevents' element={<MediaEvents/>} />  
            <Route path='/eventsdetails' element={<EventDetails/>} />
            <Route path='/absences' element={<TeamAbsences/>} /> 
            <Route path='/requestabsence' element={<RequestAbsences/>} />
            <Route path='/readinesscheck' element={<ProductionReady/>} />  
            <Route path='/skillsmatrix' element={<SkillsMatrix/>} />        
            <Route path='/birthdays' element={<TeamBirthdays/>} />      
            <Route path='/registration' element={<MemberRegistration/>} />
            <Route path='/improvements' element={<ProcessImprovements/>} />  
            <Route path='/memberprofile' element={<TeamMemberProfile/>} />
            <Route path='/memberprofileadmin' element={<TeamMemberProfileAdminAccess/>} />
            <Route path='/bestpractices' element={<BestPractices/>} />
            <Route path='/eventdetailsadmin' element={<EventDetailsAdmin/>} />
            <Route path='/eventdetailsnon' element={<EventDetailsNonMembers/>} />
            <Route path='/clockin' element={<MediaClockIn/>} />
            <Route path='/broadcastemail' element={<BroadcastEmail/>} />
            <Route path='/manageusers' element={<ManageUsers/>} />
            <Route path='/manageevents' element={<ManageEvents/>} />
            <Route path='/profileupdate' element={<MemberProfileUpdate/>} />
            <Route path='/managemembersclockin' element={<ManageMembersClockin/>} />
            <Route path='/passwordreset' element={<MemberPasswordReset/>} />
            <Route path='/passwordresetrequest' element={<MemberPasswordResetRequest/>} />
            <Route path='/managerota' element={<ManageRota/>} />
            <Route path='/createrota' element={<CreateRota/>} />
            <Route path='/manageconfig' element={<ManageConfig/>} />
            <Route path='/manageabsences' element={<ManageAbsences/>} />
            <Route path='/myabsences' element={<ManageMyAbsences/>} />
            <Route path='/managerotaroles' element={<ManageRotaRoles/>} />
            <Route path='/manageprodchecklist' element={<ManageProdChecklist/>} />
            <Route path='/productionroom' element={<InProductionRoom/>} />
            <Route path='/addincident' element={<AddIncident/>} />
            <Route path='/viewincident' element={<ViewIncident/>} />
          </Routes>
        </Router>
      </div>
      </PersistGate>
      </Provider>
  );
}

export default App;
